module.exports = __webpack_public_path__ + "img/tracer.e65b4f88.svg";